/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Scope_OnceInputs */



/**
* | output |
* | --- |
* | "Just this once" |
*
* @param {Meeting_Scope_OnceInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_scope_once = /** @type {((inputs?: Meeting_Scope_OnceInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Scope_OnceInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Alleen deze keer")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette fois seulement")
	return /** @type {LocalizedString} */ ("Just this once")
});